/**
 * @fileoverview gRPC-Web generated client stub for usrpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_type_date_pb = require('../../google/type/date_pb.js')
const proto = {};
proto.usrpb = require('./registration_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.usrpb.RegistrationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.usrpb.RegistrationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.Registration,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RegistrationService_CreateRegistration = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/CreateRegistration',
  grpc.web.MethodType.UNARY,
  proto.usrpb.Registration,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.Registration} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.Registration,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_RegistrationService_CreateRegistration = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.Registration} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.Registration} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.createRegistration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/CreateRegistration',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_CreateRegistration,
      callback);
};


/**
 * @param {!proto.usrpb.Registration} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.createRegistration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/CreateRegistration',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_CreateRegistration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.VerifyRegistrationRequest,
 *   !proto.usrpb.VerifyRegistrationResponse>}
 */
const methodDescriptor_RegistrationService_VerifyRegistration = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/VerifyRegistration',
  grpc.web.MethodType.UNARY,
  proto.usrpb.VerifyRegistrationRequest,
  proto.usrpb.VerifyRegistrationResponse,
  /**
   * @param {!proto.usrpb.VerifyRegistrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.VerifyRegistrationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.VerifyRegistrationRequest,
 *   !proto.usrpb.VerifyRegistrationResponse>}
 */
const methodInfo_RegistrationService_VerifyRegistration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.VerifyRegistrationResponse,
  /**
   * @param {!proto.usrpb.VerifyRegistrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.VerifyRegistrationResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.VerifyRegistrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.VerifyRegistrationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.VerifyRegistrationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.verifyRegistration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/VerifyRegistration',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_VerifyRegistration,
      callback);
};


/**
 * @param {!proto.usrpb.VerifyRegistrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.VerifyRegistrationResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.verifyRegistration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/VerifyRegistration',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_VerifyRegistration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.RegistrationAccount,
 *   !proto.usrpb.RegistrationAccount>}
 */
const methodDescriptor_RegistrationService_SaveRegistrationAccount = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveRegistrationAccount',
  grpc.web.MethodType.UNARY,
  proto.usrpb.RegistrationAccount,
  proto.usrpb.RegistrationAccount,
  /**
   * @param {!proto.usrpb.RegistrationAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAccount.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.RegistrationAccount,
 *   !proto.usrpb.RegistrationAccount>}
 */
const methodInfo_RegistrationService_SaveRegistrationAccount = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.RegistrationAccount,
  /**
   * @param {!proto.usrpb.RegistrationAccount} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAccount.deserializeBinary
);


/**
 * @param {!proto.usrpb.RegistrationAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.RegistrationAccount)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.RegistrationAccount>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveRegistrationAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationAccount',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationAccount,
      callback);
};


/**
 * @param {!proto.usrpb.RegistrationAccount} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.RegistrationAccount>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveRegistrationAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationAccount',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.GetRegistrationAccountRequest,
 *   !proto.usrpb.RegistrationAccount>}
 */
const methodDescriptor_RegistrationService_GetRegistrationAccount = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/GetRegistrationAccount',
  grpc.web.MethodType.UNARY,
  proto.usrpb.GetRegistrationAccountRequest,
  proto.usrpb.RegistrationAccount,
  /**
   * @param {!proto.usrpb.GetRegistrationAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAccount.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.GetRegistrationAccountRequest,
 *   !proto.usrpb.RegistrationAccount>}
 */
const methodInfo_RegistrationService_GetRegistrationAccount = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.RegistrationAccount,
  /**
   * @param {!proto.usrpb.GetRegistrationAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAccount.deserializeBinary
);


/**
 * @param {!proto.usrpb.GetRegistrationAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.RegistrationAccount)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.RegistrationAccount>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.getRegistrationAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/GetRegistrationAccount',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_GetRegistrationAccount,
      callback);
};


/**
 * @param {!proto.usrpb.GetRegistrationAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.RegistrationAccount>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.getRegistrationAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/GetRegistrationAccount',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_GetRegistrationAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.RegistrationTrustedContact,
 *   !proto.usrpb.RegistrationTrustedContact>}
 */
const methodDescriptor_RegistrationService_SaveTrustedContact = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveTrustedContact',
  grpc.web.MethodType.UNARY,
  proto.usrpb.RegistrationTrustedContact,
  proto.usrpb.RegistrationTrustedContact,
  /**
   * @param {!proto.usrpb.RegistrationTrustedContact} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationTrustedContact.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.RegistrationTrustedContact,
 *   !proto.usrpb.RegistrationTrustedContact>}
 */
const methodInfo_RegistrationService_SaveTrustedContact = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.RegistrationTrustedContact,
  /**
   * @param {!proto.usrpb.RegistrationTrustedContact} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationTrustedContact.deserializeBinary
);


/**
 * @param {!proto.usrpb.RegistrationTrustedContact} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.RegistrationTrustedContact)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.RegistrationTrustedContact>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveTrustedContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveTrustedContact',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveTrustedContact,
      callback);
};


/**
 * @param {!proto.usrpb.RegistrationTrustedContact} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.RegistrationTrustedContact>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveTrustedContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveTrustedContact',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveTrustedContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.SaveOnboardingPercentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RegistrationService_SaveOnboardingPercent = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveOnboardingPercent',
  grpc.web.MethodType.UNARY,
  proto.usrpb.SaveOnboardingPercentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.SaveOnboardingPercentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.SaveOnboardingPercentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_RegistrationService_SaveOnboardingPercent = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.SaveOnboardingPercentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.SaveOnboardingPercentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveOnboardingPercent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveOnboardingPercent',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveOnboardingPercent,
      callback);
};


/**
 * @param {!proto.usrpb.SaveOnboardingPercentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveOnboardingPercent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveOnboardingPercent',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveOnboardingPercent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.SaveRegistrationIdentificationRequest,
 *   !proto.usrpb.RegistrationAccount>}
 */
const methodDescriptor_RegistrationService_SaveRegistrationIdentification = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveRegistrationIdentification',
  grpc.web.MethodType.UNARY,
  proto.usrpb.SaveRegistrationIdentificationRequest,
  proto.usrpb.RegistrationAccount,
  /**
   * @param {!proto.usrpb.SaveRegistrationIdentificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAccount.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.SaveRegistrationIdentificationRequest,
 *   !proto.usrpb.RegistrationAccount>}
 */
const methodInfo_RegistrationService_SaveRegistrationIdentification = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.RegistrationAccount,
  /**
   * @param {!proto.usrpb.SaveRegistrationIdentificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAccount.deserializeBinary
);


/**
 * @param {!proto.usrpb.SaveRegistrationIdentificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.RegistrationAccount)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.RegistrationAccount>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveRegistrationIdentification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationIdentification',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationIdentification,
      callback);
};


/**
 * @param {!proto.usrpb.SaveRegistrationIdentificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.RegistrationAccount>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveRegistrationIdentification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationIdentification',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationIdentification);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.RegistrationEmployment,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RegistrationService_SaveRegistrationEmployment = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveRegistrationEmployment',
  grpc.web.MethodType.UNARY,
  proto.usrpb.RegistrationEmployment,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.RegistrationEmployment} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.RegistrationEmployment,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_RegistrationService_SaveRegistrationEmployment = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.RegistrationEmployment} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.RegistrationEmployment} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveRegistrationEmployment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationEmployment',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationEmployment,
      callback);
};


/**
 * @param {!proto.usrpb.RegistrationEmployment} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveRegistrationEmployment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationEmployment',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationEmployment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.RegistrationAssociation,
 *   !proto.usrpb.RegistrationAssociation>}
 */
const methodDescriptor_RegistrationService_SaveRegistrationAssociation = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveRegistrationAssociation',
  grpc.web.MethodType.UNARY,
  proto.usrpb.RegistrationAssociation,
  proto.usrpb.RegistrationAssociation,
  /**
   * @param {!proto.usrpb.RegistrationAssociation} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAssociation.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.RegistrationAssociation,
 *   !proto.usrpb.RegistrationAssociation>}
 */
const methodInfo_RegistrationService_SaveRegistrationAssociation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.RegistrationAssociation,
  /**
   * @param {!proto.usrpb.RegistrationAssociation} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAssociation.deserializeBinary
);


/**
 * @param {!proto.usrpb.RegistrationAssociation} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.RegistrationAssociation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.RegistrationAssociation>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveRegistrationAssociation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationAssociation',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationAssociation,
      callback);
};


/**
 * @param {!proto.usrpb.RegistrationAssociation} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.RegistrationAssociation>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveRegistrationAssociation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationAssociation',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationAssociation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.SaveRegistrationDisclosureRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RegistrationService_SaveRegistrationDisclosure = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveRegistrationDisclosure',
  grpc.web.MethodType.UNARY,
  proto.usrpb.SaveRegistrationDisclosureRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.SaveRegistrationDisclosureRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.SaveRegistrationDisclosureRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_RegistrationService_SaveRegistrationDisclosure = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.SaveRegistrationDisclosureRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.SaveRegistrationDisclosureRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveRegistrationDisclosure =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationDisclosure',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationDisclosure,
      callback);
};


/**
 * @param {!proto.usrpb.SaveRegistrationDisclosureRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveRegistrationDisclosure =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationDisclosure',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationDisclosure);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.SaveRegistrationTradingRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RegistrationService_SaveRegistrationTrading = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveRegistrationTrading',
  grpc.web.MethodType.UNARY,
  proto.usrpb.SaveRegistrationTradingRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.SaveRegistrationTradingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.SaveRegistrationTradingRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_RegistrationService_SaveRegistrationTrading = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.SaveRegistrationTradingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.SaveRegistrationTradingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveRegistrationTrading =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationTrading',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationTrading,
      callback);
};


/**
 * @param {!proto.usrpb.SaveRegistrationTradingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveRegistrationTrading =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationTrading',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationTrading);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.RegistrationObjective,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RegistrationService_SaveRegistrationObjective = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveRegistrationObjective',
  grpc.web.MethodType.UNARY,
  proto.usrpb.RegistrationObjective,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.RegistrationObjective} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.RegistrationObjective,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_RegistrationService_SaveRegistrationObjective = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.RegistrationObjective} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.RegistrationObjective} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveRegistrationObjective =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationObjective',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationObjective,
      callback);
};


/**
 * @param {!proto.usrpb.RegistrationObjective} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveRegistrationObjective =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationObjective',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationObjective);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.SignRegistrationRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RegistrationService_SignRegistration = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SignRegistration',
  grpc.web.MethodType.UNARY,
  proto.usrpb.SignRegistrationRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.SignRegistrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.SignRegistrationRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_RegistrationService_SignRegistration = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.usrpb.SignRegistrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.usrpb.SignRegistrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.signRegistration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SignRegistration',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SignRegistration,
      callback);
};


/**
 * @param {!proto.usrpb.SignRegistrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.signRegistration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SignRegistration',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SignRegistration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.SaveRegistrationKycRequest,
 *   !proto.usrpb.RegistrationAccount>}
 */
const methodDescriptor_RegistrationService_SaveRegistrationKyc = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/SaveRegistrationKyc',
  grpc.web.MethodType.UNARY,
  proto.usrpb.SaveRegistrationKycRequest,
  proto.usrpb.RegistrationAccount,
  /**
   * @param {!proto.usrpb.SaveRegistrationKycRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAccount.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.SaveRegistrationKycRequest,
 *   !proto.usrpb.RegistrationAccount>}
 */
const methodInfo_RegistrationService_SaveRegistrationKyc = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.RegistrationAccount,
  /**
   * @param {!proto.usrpb.SaveRegistrationKycRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.RegistrationAccount.deserializeBinary
);


/**
 * @param {!proto.usrpb.SaveRegistrationKycRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.RegistrationAccount)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.RegistrationAccount>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.saveRegistrationKyc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationKyc',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationKyc,
      callback);
};


/**
 * @param {!proto.usrpb.SaveRegistrationKycRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.RegistrationAccount>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.saveRegistrationKyc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/SaveRegistrationKyc',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_SaveRegistrationKyc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.usrpb.GetRegistrationAccountRequest,
 *   !proto.usrpb.CorpAttachmentsResponse>}
 */
const methodDescriptor_RegistrationService_GetCorpAttachments = new grpc.web.MethodDescriptor(
  '/usrpb.RegistrationService/GetCorpAttachments',
  grpc.web.MethodType.UNARY,
  proto.usrpb.GetRegistrationAccountRequest,
  proto.usrpb.CorpAttachmentsResponse,
  /**
   * @param {!proto.usrpb.GetRegistrationAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CorpAttachmentsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.usrpb.GetRegistrationAccountRequest,
 *   !proto.usrpb.CorpAttachmentsResponse>}
 */
const methodInfo_RegistrationService_GetCorpAttachments = new grpc.web.AbstractClientBase.MethodInfo(
  proto.usrpb.CorpAttachmentsResponse,
  /**
   * @param {!proto.usrpb.GetRegistrationAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.usrpb.CorpAttachmentsResponse.deserializeBinary
);


/**
 * @param {!proto.usrpb.GetRegistrationAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.usrpb.CorpAttachmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.usrpb.CorpAttachmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.usrpb.RegistrationServiceClient.prototype.getCorpAttachments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/usrpb.RegistrationService/GetCorpAttachments',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_GetCorpAttachments,
      callback);
};


/**
 * @param {!proto.usrpb.GetRegistrationAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.usrpb.CorpAttachmentsResponse>}
 *     Promise that resolves to the response
 */
proto.usrpb.RegistrationServicePromiseClient.prototype.getCorpAttachments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/usrpb.RegistrationService/GetCorpAttachments',
      request,
      metadata || {},
      methodDescriptor_RegistrationService_GetCorpAttachments);
};


module.exports = proto.usrpb;

